import React from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from 'components/shadcn';

export const LoadingButton = React.forwardRef(
  ({ children, loading = false, disabled = false, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        {...{ ...props, disabled: loading ? loading : disabled }}
      >
        {loading && <Loader2 className="animate-spin" />}
        {children}
      </Button>
    );
  },
);

LoadingButton.displayName = 'LoadingButton';
